import state from "@/store/modules/state";

export default {
    setHealthCare(healthCare) {
        state.state.health_care = healthCare
    },
    setOrderData(orderData) {
        state.state.order_data = orderData
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/mutations.js